import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=c9a87272&scoped=true&"
import script from "./Fullscreen.vue?vue&type=script&lang=js&"
export * from "./Fullscreen.vue?vue&type=script&lang=js&"
import style0 from "./Fullscreen.vue?vue&type=style&index=0&id=c9a87272&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a87272",
  null
  
)

export default component.exports